var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.variant === "only-release-date"
    ? _c(
        "time",
        {
          staticClass: "paragraph-secondary",
          class: `blog-date ${_vm.className}`,
          attrs: { datetime: _vm.formattedDate.dateTime },
        },
        [_vm._v("\n    " + _vm._s(_vm.formattedDate.release) + "\n")]
      )
    : _c(
        "div",
        {
          staticClass: "paragraph-secondary",
          class: `article-blog-date ${_vm.className}`,
        },
        [
          _c("div", [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("__publish_date")) + "\n        "
            ),
            _c("time", { attrs: { datetime: _vm.formattedDate.dateTime } }, [
              _vm._v(_vm._s(_vm.formattedDate.release)),
            ]),
          ]),
          _vm._v(" "),
          _vm.formattedDate.update
            ? _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("__updating_date")) +
                    "\n        "
                ),
                _c(
                  "time",
                  { attrs: { datetime: _vm.formattedDate.updateTime } },
                  [_vm._v(_vm._s(_vm.formattedDate.update))]
                ),
              ])
            : _vm._e(),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }